import AnnualMetricDataModel from 'scoreboard/reports/annual-metric-data/annual-metric-data-model'
import AnnualMetricDataOptionsView from './annual-metric-data-options'
import AnnualMetricDataScorecardView from './annual-metric-data-scorecard'

function validateNode(attrs, opts) {
	return !attrs.scorecardItem || !attrs.scorecardItem.id
}

var AnnualMetricDataPath = {
	icon: 'calendar',
	key: 'report.twelvePeriodReport.title',
	steps: [{
		titleCode: 'report.selectScorecardItem',
		view: AnnualMetricDataScorecardView,
		validate: validateNode
	}, {
		titleCode: 'report.twelvePeriodReport.title',
		view: AnnualMetricDataOptionsView,
		validate: function(attrs, opts) {
			return validateNode(attrs, opts) || !attrs.annualCalendarPeriodId
				|| !attrs.breakdownCalendarId
		}
	}],
	model: AnnualMetricDataModel
}

export default AnnualMetricDataPath

AnnualMetricDataPath.__filename__ = 'reports/wizard/annual-metric-data/annual-metric-data-path.js'
